import { Navigate, Outlet } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { NOT_FOUND } from "../constans/Route";
import Sidebar from "../layout/sidebar/Sidebar";
const RequireAuth = ({
  path,
  allowedRoles,
  visible,
  show,
  toggleSidebar,
  isSidebarOpen,
  setSidebarOpen,
  loggedIn,
}) => {
  const role = secureLocalStorage.getItem("role");
  const permission = [role];

  const showPage = show === undefined ? true : show;



  if (!role) {
    return <Navigate to="/" replace />;
  }



  return loggedIn ? (
    permission?.find((role) => allowedRoles?.includes(role)) && showPage ? (
      <div
        className={
          role === "admin" ? " main__section " : "main__section__company"
        }
      >
        <Sidebar
          visible={visible}
          show={show}
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />
        <div className={`p-3 h-screen w-[100vw] ${isSidebarOpen ? " lg:w-[calc(100vw_-_260px)] lg:ml-64  " : " lg:w-[calc(100vw_-_82px)] lg:ml-20 "}`}>
          <div className="rounded-[12px] mt-[80px] md:mt-[90px] lg:mt-[75px] 2xl:mt-[100px] first:h-[calc(100vh_-_115px)] 2xl:first:h-[calc(100vh_-_136px)] first:overflow-y-auto first:mr-0">
            <Outlet />
          </div>
        </div>
      </div>
    ) : (
      <Navigate to={NOT_FOUND} replace />
    )
  ) : (
    <Navigate to="/" />
  );

};
export default RequireAuth;
